import {
  PAYMENT_TYPE_CREDIT_OR_DEBIT_CARD,
  PAYMENT_TYPE_GOOGLE_PAY_APPLE_PAY,
  PAYMENT_TYPE_NONE,
  PAYMENT_TYPE_PAYPAL,
} from '@/common/constants/constants';

export const paymentOptions = [
  { value: PAYMENT_TYPE_NONE, label: 'None (Free event)' },
  { value: PAYMENT_TYPE_CREDIT_OR_DEBIT_CARD, label: 'Credit or debit card' },
  { value: PAYMENT_TYPE_GOOGLE_PAY_APPLE_PAY, label: 'Google Pay or Apple Pay' },
  { value: PAYMENT_TYPE_PAYPAL, label: 'PayPal' },
  { value: "I don't know", label: "I don't know" },
];

export const cardTypesForCreditCard = [
  { value: 'VISA', label: 'Visa' },
  { value: 'VISA_DEBIT', label: 'Visa Debit' },
  { value: 'MASTERCARD', label: 'Mastercard' },
  { value: 'MASTERCARD_DEBIT', label: 'Mastercard Debit' },
  { value: 'AMEX', label: 'American Express' },
  { value: 'DISCOVER', label: 'Discover' },
  { value: 'MAESTRO', label: 'Maestro' },
  // { value: 'IDEAL', label: 'IDEAL' },
  // { value: 'NARANJA', label: 'Naranja' },
  // { value: 'Elo', label: 'Elo' },
  // { value: 'HIPERCARD', label: 'Hipercard' },
  // { value: 'MERCADO_PAGO', label: 'Mercado Pago' },
  // { value: 'CMR', label: 'CMR' },
  // { value: 'Nativa', label: 'Nativa' },
  // { value: 'Union Pay', label: 'Union Pay' },
  // { value: 'JCB', label: 'JCB' },
];

export const cardTypesForGooglePay = [
  { value: 'VISA', label: 'Visa' },
  { value: 'VISA_DEBIT', label: 'Visa Debit' },
  { value: 'MASTERCARD', label: 'Mastercard' },
  { value: 'MASTERCARD_DEBIT', label: 'Mastercard Debit' },
  { value: 'AMEX', label: 'American Express' },
  { value: 'DISCOVER', label: 'Discover' },
  { value: 'MAESTRO', label: 'Maestro' },
  // { value: 'IDEAL', label: 'IDEAL' },
  // { value: 'NARANJA', label: 'Naranja' },
  // { value: 'Elo', label: 'Elo' },
  // { value: 'HIPERCARD', label: 'Hipercard' },
  // { value: 'MERCADO_PAGO', label: 'Mercado Pago' },
  // { value: 'CMR', label: 'CMR' },
  // { value: 'Nativa', label: 'Nativa' },
  // { value: 'Union Pay', label: 'Union Pay' },
  // { value: 'JCB', label: 'JCB' },
];
